import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Repository } from "typeorm";
import { UnitTwelevFileUploadEntity } from "../dto/unit-twleve-file.entity";


@Injectable()
export class UnitTwelveRepo extends Repository<UnitTwelevFileUploadEntity> {

    constructor(@InjectRepository(UnitTwelevFileUploadEntity) private unitTwleveRepo: Repository<UnitTwelevFileUploadEntity>
    ) {
        super(unitTwleveRepo.target, unitTwleveRepo.manager, unitTwleveRepo.queryRunner);
    }

    async getUnitTwelvePDFInfo(req?: any): Promise<any[]> {
        const query = this.createQueryBuilder('utf')
            .select(`*`);
        return await query.getRawMany();
    }

}